
export class HighchartsService {

  /**
   * if max value is 1.06 -> tickPositions =[0, 0.5, 1, 1.5]
   * if max value is 1.46 -> tickPositions =[0, 0.5, 1, 1.5]
   * if max value is 1.96 -> tickPositions =[0, 0.5, 1, 1.5, 2]
   */
  static calculateTickPositions(maxValue: number): number[] {
    let roundedMax = Math.ceil(maxValue * 2) / 2;

    let tickPositions = [];
    for (let value = 0; value <= roundedMax; value += 0.5) {
      tickPositions.push(value);
    }

    return tickPositions;
  }

    /**
     * Determine the rotation angle for xAxis labels based on the number of categories
     *  - If there are more than 15 categories, set the rotation to -90 degrees
     *  - If there are fewer than 5 categories, set the rotation to 0 degrees (no rotation)
     *  - Otherwise, set the rotation to -45 degrees for moderate congestion of categories
     */ 

  static changeRotationOfCategories(categoriesLength: number): number {

    if (categoriesLength > 15) {
        return -90;
    } else if (categoriesLength < 5) {
        return 0;
    } else {
        return -45;
    }
  }
}